module.exports = __webpack_public_path__ + "img/img_4.81deefde.png";